const _tableImport = {
    excleHead: [
        // status
        {
            title: "Status Import",
            dataIndex: "status_import",
            scopedSlots: { customRender: "status_import" },
            width: 100,
            // fixed: "left",
            className: "center-colum column-header-fix-data-s",
        },
        // status detail
        {
            title: "Status Import Detail",
            dataIndex: "status_detail",
            scopedSlots: { customRender: "status_detail" },
            width: 150,
            // fixed: "left",
        className: "center-colum column-header-fix-data-s",
        },
       
        {
            title: "Student_ID",
            dataIndex: "student_id",
            key: "student_id",
            width: 80,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Academic Title EN",
            dataIndex: "academic_title_en",
            key: "academic_title_en",
            width: 80,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },  
        {
            title: "Title EN",
            dataIndex: "title_name_en",
            key: "title_en",
            width: 80,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },  
        {
            title: "Name ENG",
            dataIndex: "name_en",
            scopedSlots: { customRender: "name_en" },
            // fixed: "left",
            width: 150,
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Academic Title TH",
            dataIndex: "academic_title_th",
            key: "academic_title_th",
            width: 80,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },  
        {
            title: "Title TH",
            dataIndex: "title_name_th",
            key: "title_th",
            width: 80,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },  
        {
            title: "Name TH",
            dataIndex: "name_th",
            scopedSlots: { customRender: "name_th" },
            // fixed: "left",
            width: 150,
            className: "center-colum column-header-fix-data",
        }
    ],
}

export default _tableImport;
